// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account {
  background-color: #f1f1f1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 100vh;
  overflow: auto;
}
.account__header {
  padding: 25px 100px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .account__header {
    padding: 25px 35px;
  }
}
@media (max-width: 768px) {
  .account__header {
    padding: 25px 15px;
  }
}
.account__header-content {
  display: flex;
  justify-content: space-between;
}
.account__header-logout {
  font-size: 20px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  cursor: pointer;
}
@media (max-width: 480px) {
  .account__header-logout {
    font-size: 18px;
  }
}
.account__header-logout:hover {
  color: #991e1e;
}
.account__greeting {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__greeting-card {
  width: 600px;
  height: 320px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding-bottom: 25px;
}
@media (max-width: 575px) {
  .account__greeting-card {
    width: 500px;
  }
}
@media (max-width: 480px) {
  .account__greeting-card {
    width: 450px;
  }
}
@media (max-width: 450px) {
  .account__greeting-card {
    width: 400px;
  }
}
@media (max-width: 400px) {
  .account__greeting-card {
    width: 380px;
  }
}
.account__greeting-card__image img {
  display: block;
  width: 600px;
  height: 250px;
  border-radius: 10px;
  filter: brightness(100%);
}
@media (max-width: 575px) {
  .account__greeting-card__image img {
    width: 500px;
  }
}
@media (max-width: 500px) {
  .account__greeting-card__image img {
    width: 450px;
  }
}
@media (max-width: 450px) {
  .account__greeting-card__image img {
    width: 400px;
  }
}
@media (max-width: 400px) {
  .account__greeting-card__image img {
    width: 380px;
  }
}
.account__greeting-card__name {
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: rgb(7, 7, 7);
  padding-top: 15px;
}
@media (max-width: 575px) {
  .account__greeting-card__name {
    font-size: 20px;
  }
}
@media (max-width: 450px) {
  .account__greeting-card__name {
    font-size: 18px;
  }
}
.account__filter {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__filter-card {
  width: 600px;
  height: 54px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
@media (max-width: 575px) {
  .account__filter-card {
    width: 500px;
  }
}
@media (max-width: 480px) {
  .account__filter-card {
    width: 450px;
    height: 30px;
  }
}
@media (max-width: 480px) {
  .account__filter-card {
    width: 450px;
  }
}
@media (max-width: 450px) {
  .account__filter-card {
    width: 400px;
  }
}
@media (max-width: 400px) {
  .account__filter-card {
    width: 380px;
  }
}
.account__filter-card__content {
  display: flex;
  justify-content: space-between;
}
.account__filter-card__item {
  font-size: 16px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  cursor: pointer;
  padding: 15px 25px;
  border-radius: 10px;
  list-style: none;
  transition: background-color 0.1s ease-in-out;
}
@media (max-width: 575px) {
  .account__filter-card__item {
    font-size: 14px;
    padding: 17px 25px;
  }
}
@media (max-width: 500px) {
  .account__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 450px) {
  .account__filter-card__item {
    padding: 5px 13px;
  }
}
@media (max-width: 450px) {
  .account__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 400px) {
  .account__filter-card__item {
    font-size: 13px;
  }
}
.account__filter-card__item:hover {
  background-color: #2131e1;
  color: white;
}
.account__filter-card__item:active {
  background-color: #1d2cd5;
}
.account__filter-card__item.active {
  background-color: #1d2cd5;
  color: white;
}
.account__description {
  margin-top: 10px;
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__description-card {
  width: 600px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
@media (max-width: 575px) {
  .account__description-card {
    width: 500px;
  }
}
@media (max-width: 480px) {
  .account__description-card {
    width: 450px;
  }
}
@media (max-width: 450px) {
  .account__description-card {
    width: 400px;
  }
}
@media (max-width: 400px) {
  .account__description-card {
    width: 380px;
  }
}
.account__description-card__content {
  padding: 35px 25px;
}
.account__description .manager__content {
  display: flex;
  justify-content: left;
}
.account__description .manager__title {
  font-size: 19px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  padding-right: 25px;
}
@media (max-width: 480px) {
  .account__description .manager__title {
    font-size: 17px;
    padding-right: 20px;
  }
}
.account__description .manager__name {
  font-size: 19px;
  font-weight: 400;
  color: rgb(118, 109, 109);
}
@media (max-width: 480px) {
  .account__description .manager__name {
    font-size: 17px;
  }
}
.account__description .manager__phone {
  font-size: 19px;
  font-weight: 400;
  color: rgb(193, 15, 15);
}
@media (max-width: 480px) {
  .account__description .manager__phone {
    font-size: 17px;
  }
}
.account__description .manager__phone:hover {
  color: rgb(193, 15, 15);
}
.account__description .brigade {
  margin-top: 25px;
}
.account__description .brigade__content {
  display: flex;
  justify-content: left;
}
.account__description .brigade__title {
  font-size: 19px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  padding-right: 25px;
}
@media (max-width: 480px) {
  .account__description .brigade__title {
    font-size: 17px;
    padding-right: 20px;
  }
}
.account__description .brigade__foreman {
  font-size: 19px;
  font-weight: 400;
  color: rgb(118, 109, 109);
}
@media (max-width: 480px) {
  .account__description .brigade__foreman {
    font-size: 17px;
  }
}
.account__description .brigade__phone {
  font-size: 19px;
  font-weight: 400;
  color: rgb(193, 15, 15);
  margin-bottom: 25px;
}
@media (max-width: 480px) {
  .account__description .brigade__phone {
    font-size: 17px;
  }
}
.account__description .brigade__phone:hover {
  color: rgb(193, 15, 15);
}
.account__description .brigade-image img {
  width: 100%;
  height: 90%;
  border-radius: 10px;
  cursor: pointer;
}
.account__description .brigade .image-container {
  cursor: pointer;
}
.account__description .brigade .image-container img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}
.account__description .brigade .full-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__description .brigade .full-screen img {
  width: auto;
  height: auto;
  max-width: 90vw;
  max-height: 90vh;
}
.account__description .project__items {
  display: flex;
  justify-content: left;
  margin-top: 15px;
}
.account__description .project__title {
  font-size: 19px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  padding-right: 25px;
}
@media (max-width: 450px) {
  .account__description .project__title {
    font-size: 17px;
    padding-right: 20px;
  }
}
.account__description .project__description {
  font-size: 19px;
  font-weight: 500;
  color: #372dd3;
}
@media (max-width: 450px) {
  .account__description .project__description {
    font-size: 17px;
  }
}
.account__description .file__content {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
}
.account__description .file__item {
  font-size: 19px;
  font-weight: 500;
  color: #372dd3;
  cursor: pointer;
}
@media (max-width: 450px) {
  .account__description .file__item {
    font-size: 17px;
  }
}
.account__description .image__content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 5px;
  grid-row-gap: 10px;
  justify-content: center;
}
@media (max-width: 480px) {
  .account__description .image__content {
    grid-template-columns: repeat(1, 1fr);
  }
}
.account__description .image .image-card img {
  width: 250px;
  height: 250px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  cursor: pointer;
}
@media (max-width: 575px) {
  .account__description .image .image-card img {
    width: 220px;
    height: 200px;
  }
}
@media (max-width: 480px) {
  .account__description .image .image-card img {
    display: block;
    margin: 0 auto;
    width: 350px;
    height: 350px;
  }
}
.account__description .image .full-card {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__description .image .full-card img {
  width: auto;
  height: auto;
  max-width: 90vw;
  max-height: 90vh;
}
.account__description .image__card img {
  width: 250px;
  height: 250px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  cursor: pointer;
}
@media (max-width: 575px) {
  .account__description .image__card img {
    width: 220px;
    height: 200px;
  }
}
@media (max-width: 480px) {
  .account__description .image__card img {
    display: block;
    margin: 0 auto;
    width: 350px;
    height: 350px;
  }
}
.account__description .image__date {
  padding-top: 8px;
  font-size: 18px;
  font-weight: 500;
  color: rgb(118, 109, 109);
  text-align: center;
}
.account__file {
  margin-top: 15px;
}
.account__file-title {
  font-size: 22px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  padding-right: 15px;
}
@media (max-width: 575px) {
  .account__file-title {
    font-size: 22px;
  }
}
.account__file-items {
  display: flex;
}
.account__file-item {
  font-size: 22px;
  font-weight: 400;
  color: rgb(193, 15, 15);
  padding-right: 10px;
  cursor: pointer;
}
@media (max-width: 575px) {
  .account__file-item {
    font-size: 18px;
  }
}
.account__brigade {
  margin-top: 15px;
}
.account__brigade-content {
  display: flex;
}
.account__brigade-title {
  font-size: 22px;
  font-weight: 400;
  color: rgb(118, 109, 109);
  padding-right: 15px;
}
@media (max-width: 575px) {
  .account__brigade-title {
    font-size: 22px;
  }
}
.account__brigade-foreman {
  font-size: 22px;
  font-weight: 400;
  color: rgb(118, 109, 109);
}
.account__brigade-phone {
  font-size: 22px;
  font-weight: 400;
  color: rgb(193, 15, 15);
  padding-left: 15px;
}
.account__brigade-phone:hover {
  color: rgb(193, 15, 15);
}
.account__brigade-foto {
  font-size: 22px;
  font-weight: 400;
  color: rgb(193, 15, 15);
  padding-left: 15px;
  cursor: pointer;
}
.account__brigade-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.account__brigade-image img {
  max-width: 90%;
  max-height: 90%;
}
.account__image {
  padding-top: 25px;
}
.account__image-title {
  font-size: 25px;
  font-weight: 500;
  color: rgb(118, 109, 109);
  text-align: center;
}
@media (max-width: 575px) {
  .account__image-title {
    font-size: 22px;
  }
}
.account__image-content {
  padding-top: 25px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 5px;
  margin-bottom: 25px;
}
@media (max-width: 480px) {
  .account__image-content {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 15px;
  }
}
.account__image-card img {
  width: 350px;
  height: 350px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .account__image-card img {
    width: 300px;
    height: 300px;
  }
}
@media (max-width: 991px) {
  .account__image-card img {
    width: 280px;
    height: 280px;
  }
}
@media (max-width: 768px) {
  .account__image-card img {
    width: 220px;
    height: 220px;
  }
}
@media (max-width: 575px) {
  .account__image-card img {
    width: 180px;
    height: 180px;
  }
}
@media (max-width: 480px) {
  .account__image-card img {
    width: 180px;
    height: 180px;
  }
}
.account__image-date {
  padding-top: 8px;
  font-size: 18px;
  font-weight: 500;
  color: rgb(118, 109, 109);
  text-align: center;
}
@media (max-width: 575px) {
  .account__image-date {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ClientAccountList/CreateInformationClientList/style.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,cAAA;AAAJ;AAKI;EACI,mBAAA;EACA,uBAAA;EACA,wCAAA;AAHR;AAIQ;EAJJ;IAKQ,kBAAA;EADV;AACF;AAEQ;EAPJ;IAQQ,kBAAA;EACV;AACF;AACQ;EACI,aAAA;EACA,8BAAA;AACZ;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAZ;AACY;EALJ;IAMQ,eAAA;EAEd;AACF;AADY;EACI,cAAA;AAGhB;AAEI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,oBAAA;AAAZ;AACY;EAPJ;IAQQ,YAAA;EAEd;AACF;AADY;EAVJ;IAWQ,YAAA;EAId;AACF;AAHY;EAbJ;IAcQ,YAAA;EAMd;AACF;AALY;EAhBJ;IAiBQ,YAAA;EAQd;AACF;AAJgB;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AAMpB;AALoB;EANJ;IAOQ,YAAA;EAQtB;AACF;AAPoB;EATJ;IAUQ,YAAA;EAUtB;AACF;AAToB;EAZJ;IAaQ,YAAA;EAYtB;AACF;AAXoB;EAfJ;IAgBQ,YAAA;EActB;AACF;AAVY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAYhB;AAXgB;EANJ;IAOQ,eAAA;EAclB;AACF;AAbgB;EATJ;IAUQ,eAAA;EAgBlB;AACF;AAVI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAYR;AAVQ;EACI,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;AAYZ;AAXY;EANJ;IAOQ,YAAA;EAcd;AACF;AAbY;EATJ;IAUQ,YAAA;IACA,YAAA;EAgBd;AACF;AAfY;EAbJ;IAcQ,YAAA;EAkBd;AACF;AAjBY;EAhBJ;IAiBQ,YAAA;EAoBd;AACF;AAnBY;EAnBJ;IAoBQ,YAAA;EAsBd;AACF;AApBY;EAEI,aAAA;EACA,8BAAA;AAqBhB;AAlBY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;AAoBhB;AAnBgB;EATJ;IAUQ,eAAA;IACA,kBAAA;EAsBlB;AACF;AArBgB;EAbJ;IAcQ,iBAAA;EAwBlB;AACF;AAvBgB;EAhBJ;IAiBQ,iBAAA;EA0BlB;AACF;AAzBgB;EAnBJ;IAoBQ,iBAAA;EA4BlB;AACF;AA3BgB;EAtBJ;IAuBQ,eAAA;EA8BlB;AACF;AA5BgB;EACE,yBAAA;EACA,YAAA;AA8BlB;AA3BgB;EACE,yBAAA;AA6BlB;AAzBgB;EACI,yBAAA;EACA,YAAA;AA2BpB;AArBI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAuBR;AArBQ;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;AAuBZ;AAtBY;EALJ;IAMQ,YAAA;EAyBd;AACF;AAxBY;EARJ;IASQ,YAAA;EA2Bd;AACF;AA1BY;EAXJ;IAYQ,YAAA;EA6Bd;AACF;AA5BY;EAdJ;IAeQ,YAAA;EA+Bd;AACF;AA7BY;EACI,kBAAA;AA+BhB;AA1BY;EACI,aAAA;EACA,qBAAA;AA4BhB;AA1BY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AA4BhB;AA3BgB;EALJ;IAMQ,eAAA;IACA,mBAAA;EA8BlB;AACF;AA1BY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AA4BhB;AA3BgB;EAJJ;IAKQ,eAAA;EA8BlB;AACF;AA1BY;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AA4BhB;AA3BgB;EAJJ;IAKQ,eAAA;EA8BlB;AACF;AA5BgB;EACI,uBAAA;AA8BpB;AAzBQ;EACI,gBAAA;AA2BZ;AAxBY;EACI,aAAA;EACA,qBAAA;AA0BhB;AAtBY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAwBhB;AAvBgB;EALJ;IAMQ,eAAA;IACA,mBAAA;EA0BlB;AACF;AAtBY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AAwBhB;AAvBgB;EAJJ;IAKQ,eAAA;EA0BlB;AACF;AAtBY;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwBhB;AAvBgB;EALJ;IAMQ,eAAA;EA0BlB;AACF;AAxBgB;EACI,uBAAA;AA0BpB;AArBgB;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAuBpB;AAlBY;EAEI,eAAA;AAmBhB;AAlBgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAoBpB;AAhBc;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAkBhB;AAjBgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAmBpB;AAZY;EACI,aAAA;EACA,qBAAA;EACA,gBAAA;AAchB;AAXY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAahB;AAZgB;EALJ;IAMQ,eAAA;IACA,mBAAA;EAelB;AACF;AAZY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAchB;AAbgB;EAJJ;IAKQ,eAAA;EAgBlB;AACF;AATY;EACI,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AAWhB;AARY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAUhB;AATgB;EALJ;IAMQ,eAAA;EAYlB;AACF;AAJY;EACI,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;AAMhB;AALgB;EANJ;IAOQ,qCAAA;EAQlB;AACF;AAHgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAKpB;AAJoB;EANJ;IAOQ,YAAA;IACA,aAAA;EAOtB;AACF;AANoB;EAVJ;IAWQ,cAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;EAStB;AACF;AALY;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAOhB;AANgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAQpB;AAHgB;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAKpB;AAJoB;EANJ;IAOQ,YAAA;IACA,aAAA;EAOtB;AACF;AANoB;EAVJ;IAWQ,cAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;EAStB;AACF;AALY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAOhB;AAII;EACI,gBAAA;AAFR;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAFZ;AAGY;EALJ;IAMQ,eAAA;EAAd;AACF;AAGQ;EACI,aAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFZ;AAGY;EANJ;IAOQ,eAAA;EAAd;AACF;AAII;EACI,gBAAA;AAFR;AAIQ;EACI,aAAA;AAFZ;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAHZ;AAIY;EALJ;IAMQ,eAAA;EADd;AACF;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AAFZ;AAKQ;EACQ,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAHhB;AAIgB;EACI,uBAAA;AAFpB;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAHZ;AAOQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALZ;AAOY;EACI,cAAA;EACA,eAAA;AALhB;AAWI;EACI,iBAAA;AATR;AAWQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AATZ;AAUY;EALJ;IAMQ,eAAA;EAPd;AACF;AAUQ;EACI,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,mBAAA;AARZ;AASY;EANJ;IAOQ,qCAAA;IACA,mBAAA;EANd;AACF;AAWY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAThB;AAUgB;EANJ;IAOQ,YAAA;IACA,aAAA;EAPlB;AACF;AAQgB;EAVJ;IAWQ,YAAA;IACA,aAAA;EALlB;AACF;AAMgB;EAdJ;IAeQ,YAAA;IACA,aAAA;EAHlB;AACF;AAIgB;EAlBJ;IAmBQ,YAAA;IACA,aAAA;EADlB;AACF;AAEgB;EAtBJ;IAuBQ,YAAA;IACA,aAAA;EAClB;AACF;AAIQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAFZ;AAGY;EANJ;IAOQ,eAAA;EAAd;AACF","sourcesContent":[".account {\n    background-color: #f1f1f1;\n    position: fixed; \n    top: 0; \n    left: 0; \n    right: 0;\n    bottom: 0;\n  \n    max-height: 100vh;\n    overflow: auto;\n    \n    \n    \n\n    &__header {\n        padding: 25px 100px;\n        background-color: #ffff;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        @media(max-width: 768px) {\n            padding: 25px 35px;\n        }\n        @media(max-width: 768px) {\n            padding: 25px 15px;\n        }\n\n        &-content {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        &-logout {\n            font-size: 20px;\n            font-weight: 400;\n            color: rgb(7,7,7);\n            cursor: pointer;\n            @media(max-width: 480px) {\n                font-size: 18px;\n            }\n            &:hover {\n                color:#991e1e\n            }\n        }\n    }\n\n    &__greeting {\n        margin-top: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &-card {\n            width: 600px;\n            height: 320px;\n            background-color: #ffff;\n            border-radius: 10px;\n            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n            padding-bottom: 25px;\n            @media(max-width: 575px) {\n                width: 500px;\n            }\n            @media(max-width: 480px) {\n                width: 450px;\n            }\n            @media (max-width: 450px) {\n                width: 400px;\n            }\n            @media (max-width: 400px) {\n                width: 380px;\n            }\n\n            &__image {\n                \n                img {\n                    display: block;\n                    width: 600px;\n                    height: 250px;\n                    border-radius: 10px;\n                    filter: brightness(100%);\n                    @media(max-width: 575px) {\n                        width: 500px;\n                    }\n                    @media(max-width: 500px) {\n                        width: 450px;\n                    }\n                    @media (max-width: 450px) {\n                        width: 400px;\n                    }\n                    @media (max-width: 400px) {\n                        width: 380px;\n                    }\n                }\n            }\n\n            &__name {\n                text-align: center;\n                font-size: 22px;\n                font-weight: 500;\n                color: rgb( 7 7 7);\n                padding-top: 15px;\n                @media (max-width: 575px) {\n                    font-size: 20px;\n                }\n                @media (max-width: 450px) {\n                    font-size: 18px;\n                }\n\n            }\n        }\n    }\n\n    &__filter {\n        margin-top: 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &-card {\n            width: 600px;\n            height: 54px;\n            background-color: #ffff;\n            border-radius: 10px;\n            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n            @media(max-width: 575px) {\n                width: 500px;\n            }\n            @media(max-width: 480px) {\n                width: 450px;\n                height: 30px;\n            }\n            @media (max-width: 480px) {\n                width: 450px;;\n            }\n            @media (max-width: 450px) {\n                width: 400px;\n            }\n            @media (max-width: 400px) {\n                width: 380px;\n            }\n\n            &__content {\n                \n                display: flex;\n                justify-content: space-between;\n            }\n\n            &__item {\n                font-size: 16px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                cursor: pointer;\n                padding: 15px 25px;\n                border-radius: 10px;\n                list-style: none;\n                transition: background-color 0.1s ease-in-out;\n                @media(max-width: 575px) {\n                    font-size: 14px;\n                    padding: 17px 25px;\n                }\n                @media (max-width: 500px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 13px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 400px) {\n                    font-size: 13px;\n                }\n          \n                &:hover {\n                  background-color: darken(#2a39e2, 2%);\n                  color: #ffff;\n                }\n          \n                &:active {\n                  background-color: darken(#2a39e2, 5%);\n                 \n                }\n          \n                &.active {\n                    background-color: darken(#2a39e2, 5%);\n                    color: #ffff;\n                  }\n            }\n        }\n    }\n\n    &__description {\n        margin-top: 10px;\n        margin-bottom: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &-card {\n            width: 600px;\n            background-color: #ffff;\n            border-radius: 10px;\n            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n            @media(max-width: 575px) {\n                width: 500px;\n            }\n            @media(max-width:480px) {\n                width: 450px;\n            }\n            @media (max-width: 450px) {\n                width: 400px;\n            }\n            @media (max-width: 400px) {\n                width: 380px;\n            }\n            \n            &__content {\n                padding: 35px 25px;\n            }\n        }\n    // information\n        .manager {\n            &__content {\n                display: flex;\n                justify-content: left;\n            }\n            &__title {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                padding-right: 25px;\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                    padding-right: 20px;\n                }\n                \n            }\n\n            &__name {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                 \n                }\n            }\n\n            &__phone {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(193 15 15);\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                   \n                }\n                &:hover {\n                    color:rgb(193 15 15);\n                }\n            }\n        }\n\n        .brigade {\n            margin-top: 25px;\n           \n\n            &__content {\n                display: flex;\n                justify-content: left;\n                \n            }\n\n            &__title {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                padding-right: 25px;\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                    padding-right: 20px;\n                }\n                \n            }\n\n            &__foreman {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                    \n                }\n            }\n\n            &__phone {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(193 15 15);\n                margin-bottom: 25px;\n                @media (max-width: 480px) {\n                    font-size: 17px;\n                  \n                }\n                &:hover {\n                    color:rgb(193 15 15);\n                }\n            }\n\n            &-image {\n                img {\n                    width: 100%;\n                    height: 90%;\n                    border-radius: 10px;\n                    cursor: pointer;\n                    \n                }\n            }\n\n            .image-container {\n         \n                cursor: pointer;\n                img {\n                    width: 100%; \n                    height: auto;\n                    border-radius: 10px;\n                }\n              }\n              \n              .full-screen {\n                position: fixed;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n                background-color: rgba(0, 0, 0, 1.4);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                img {\n                    width: auto; \n                    height: auto;\n                    max-width: 90vw;\n                    max-height: 90vh;\n                  }\n              }\n        }\n\n        // project\n        .project {\n            &__items {\n                display: flex;\n                justify-content: left;\n                margin-top: 15px;\n            }\n\n            &__title {\n                font-size: 19px;\n                font-weight: 400;\n                color: rgb(118 109 109);\n                padding-right: 25px;\n                @media (max-width: 450px) {\n                    font-size: 17px;\n                    padding-right: 20px;\n                }\n            }\n\n            &__description {\n                font-size: 19px;\n                font-weight: 500;\n                color: #372dd3;\n                @media (max-width: 450px) {\n                    font-size: 17px;\n                    \n                }\n            }\n        }\n\n        // file \n        .file {\n            &__content {\n                display: grid;\n                grid-template-columns: repeat(1, 1fr);\n                grid-template-rows: 1fr;\n                grid-column-gap: 5px;\n                grid-row-gap: 5px;\n            }\n\n            &__item {\n                font-size: 19px;\n                font-weight: 500;\n                color: #372dd3;\n                cursor: pointer;\n                @media (max-width: 450px) {\n                    font-size: 17px;\n                   \n                }\n            }\n            \n        }\n\n        // images \n        .image {\n            &__content {\n                display: grid;\n                grid-template-columns: repeat(2, 1fr);\n                grid-column-gap: 5px;\n                grid-row-gap: 10px;\n                justify-content: center;\n                @media (max-width: 480px) {\n                    grid-template-columns: repeat(1, 1fr);\n                }\n\n            }\n\n            .image-card {\n                img {\n                    width: 250px; \n                    height: 250px;\n                    border-radius: 5px;\n                    border: 1px solid #ffffff;\n                    cursor: pointer;\n                    @media (max-width: 575px) {\n                        width: 220px;\n                        height: 200px;\n                    }\n                    @media (max-width: 480px) {\n                        display: block;\n                        margin: 0 auto;\n                        width: 350px;\n                        height: 350px;\n                    }\n                }\n            }\n\n            .full-card {\n                position: fixed;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n                background-color: rgba(0, 0, 0, 1.4);\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                img {\n                    width: auto; \n                    height: auto;\n                    max-width: 90vw;\n                    max-height: 90vh;\n                  }\n              }\n\n            &__card {\n                img {\n                    width: 250px; \n                    height: 250px;\n                    border-radius: 5px;\n                    border: 1px solid #ffffff;\n                    cursor: pointer;\n                    @media (max-width: 575px) {\n                        width: 220px;\n                        height: 200px;\n                    }\n                    @media (max-width: 480px) {\n                        display: block;\n                        margin: 0 auto;\n                        width: 350px;\n                        height: 350px;\n                    }\n                }\n            }\n    \n            &__date {\n                padding-top: 8px;\n                font-size: 18px;\n                font-weight: 500;\n                color: rgb(118 109 109); \n                text-align: center;\n            }\n        }\n        \n\n        \n    }\n\n  \n   \n\n    &__file {\n        margin-top: 15px;\n\n        &-title {\n            font-size: 22px;\n            font-weight: 400;\n            color: rgb(118 109 109); \n            padding-right: 15px;\n            @media(max-width: 575px) {\n                font-size: 22px\n            }\n        }\n\n        &-items {\n            display: flex;\n        }\n\n        &-item {\n            font-size: 22px;\n            font-weight: 400;\n            color: rgb(193 15 15);\n            padding-right: 10px;\n            cursor: pointer;\n            @media(max-width: 575px) {\n                font-size: 18px\n            }\n        }\n    }\n\n    &__brigade {\n        margin-top: 15px;\n\n        &-content {\n            display: flex; \n        }\n\n        &-title {\n            font-size: 22px;\n            font-weight: 400;\n            color: rgb(118 109 109);   \n            padding-right: 15px; \n            @media(max-width: 575px) {\n                font-size: 22px\n            }\n        }\n\n        &-foreman {\n            font-size: 22px;\n            font-weight: 400;\n            color: rgb(118 109 109);\n        }\n\n        &-phone {\n                font-size: 22px;\n                font-weight: 400;\n                color: rgb(193 15 15);\n                padding-left: 15px;\n                &:hover {\n                    color:rgb(193 15 15);\n                }\n            }\n        &-foto {\n            font-size: 22px;\n            font-weight: 400;\n            color: rgb(193 15 15);\n            padding-left: 15px;\n            cursor: pointer;\n        }\n        \n\n        &-image {\n            position: fixed;\n            top: 0;\n            left: 0;\n            width: 100vw;\n            height: 100vh;\n            background-color: rgba(0, 0, 0, 0.8);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            \n            img {\n                max-width: 90%;\n                max-height: 90%;\n            }\n           \n        }\n    }\n\n    &__image {\n        padding-top: 25px;\n\n        &-title {\n            font-size: 25px;\n            font-weight: 500;\n            color: rgb(118 109 109);  \n            text-align: center;\n            @media(max-width: 575px) {\n                font-size: 22px\n            }\n        }\n\n        &-content {\n            padding-top: 25px;\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n            grid-column-gap: 5px;\n            margin-bottom: 25px;\n            @media (max-width: 480px) {\n                grid-template-columns: repeat(2, 1fr);\n                margin-bottom: 15px;\n            }\n        }\n\n        &-card {\n           \n            img {\n                width: 350px; \n                height: 350px;\n                border-radius: 5px;\n                border: 1px solid #ffffff;\n                cursor: pointer;\n                @media(max-width: 1024px) {\n                    width: 300px;\n                    height: 300px;\n                }\n                @media(max-width: 991px) {\n                    width: 280px;\n                    height: 280px;\n                }\n                @media(max-width: 768px) {\n                    width: 220px;\n                    height: 220px;\n                }\n                @media(max-width: 575px) {\n                    width:  180px;\n                    height: 180px;\n                } \n                @media(max-width: 480px) {\n                    width:  180px;\n                    height: 180px;\n                } \n                \n            }\n        }\n\n        &-date {\n            padding-top: 8px;\n            font-size: 18px;\n            font-weight: 500;\n            color: rgb(118 109 109); \n            text-align: center;\n            @media(max-width: 575px) {\n                font-size: 16px\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
